import type { PlenaryActivityInformation } from '@hendrx/lms/contracts/server';

export function getPlenaryActivityInformation(url: URL): PlenaryActivityInformation {
  const segments = url.pathname.split('/').filter(Boolean);
  const playerIndex = segments.findIndex(segment => segment === 'player');
  const courseDraftId = url.searchParams.get('courseDraftId') ?? '';
  const courseCategoryId = url.searchParams.get('courseCategoryId') ?? '';
  const courseEnvironmentId = url.searchParams.get('courseEnvironmentId') ?? '';

  if (playerIndex === -1) {
    return { type: 'regular', id: '', courseDraftId, courseCategoryId: '', courseEnvironmentId: '' };
  }

  const remainingSegments = segments.slice(playerIndex + 1);
  if (remainingSegments.length === 0) {
    return { type: 'regular', id: '', courseDraftId, courseCategoryId, courseEnvironmentId };
  }

  const assignmentIndex = remainingSegments.findIndex(segment => segment === 'assignment');
  const isAssignment = assignmentIndex !== -1;

  if (isAssignment) {
    // Get the ID that comes after 'assignment'
    const id = remainingSegments[assignmentIndex + 1] || '';
    return { type: 'assignment', id, courseDraftId, courseCategoryId, courseEnvironmentId };
  }

  // For regular type, the ID is the last segment that's not 'plenary'
  const nonPlenarySegments = remainingSegments.filter(segment => segment !== 'plenary');
  const id = nonPlenarySegments[0] || '';
  return { type: 'regular', id, courseDraftId, courseCategoryId, courseEnvironmentId };
}
